import { render } from "./BetRules.vue?vue&type=template&id=3a2c6f1a"
import script from "./BetRules.vue?vue&type=script&lang=js"
export * from "./BetRules.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__